import { render } from "./HotelIndex.vue?vue&type=template&id=0d94323a&scoped=true"
import script from "./HotelIndex.vue?vue&type=script&lang=js"
export * from "./HotelIndex.vue?vue&type=script&lang=js"

import "@/assets/styles/hotel.css?vue&type=style&index=0&id=0d94323a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d94323a"]])

export default __exports__